module.exports = __webpack_public_path__ + "static/img/lunbo2.1cdf0b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lunbo2.jpg
// module id = BncM
// module chunks = 1